import * as React from 'react'
import styled from 'styled-components'

import * as model from '@owl-nest/models'
import * as layout from '../layout'
import { LinkAsButton, Button, styles as S, COLORS } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'

const Coach = styled(layout.Coach)`
  ${S.modal.Title} {
    background-color: ${COLORS.PRIMARY_GREEN};
  }
  ${Button} {
    width: 100%;
  }
`

type ValidatedProps = {
  initialOpen: boolean
  project: projectModel.Project
  markStepDone: () => Promise<void>
}

export function Validated({
  project,
  initialOpen,
  markStepDone,
}: ValidatedProps): React.ReactElement<ValidatedProps> | null {
  const manager = project.manager || project.default_manager
  const [open, setIsOpen] = React.useState(initialOpen)

  if (manager === undefined) {
    return null
  }

  const managerAvatar = model.image.getUrl(manager.avatar.versions, '128x128')

  return (
    <Coach
      closable={true}
      open={open}
      title={t('Project verified')}
      onClose={handleDone}
      titleBackgroundColor={COLORS.PRIMARY_GREEN}
      avatar={managerAvatar}
    >
      <S.heading.XS>{t('Great news %(owner)s 👏', { owner: model.user.fullName(project.owner) })}</S.heading.XS>

      <S.copy.S.regular>
        {t('%(manager)s verified your project, it’s now time to publish it whenever you’re ready!', {
          manager: model.user.fullName(manager),
        })}
      </S.copy.S.regular>

      <S.copy.S.regular>{t('Let’s go 👇')}</S.copy.S.regular>

      <Button color="green" onClick={goToPublish}>
        {t('Publish my project')}
      </Button>

      <LinkAsButton kind="secondary" onClick={goToDiscussion}>
        {t('Read our advice')}
      </LinkAsButton>
    </Coach>
  )

  async function handleDone(): Promise<void> {
    setIsOpen(false)
    markStepDone()
  }

  async function goToPublish(): Promise<void> {
    await markStepDone()
    window.location.href = `/projects/${project.id}/backoffice/launch/`
  }

  async function goToDiscussion(): Promise<void> {
    await markStepDone()
    window.location.href = `/projects/${project.id}/discussion/#last-message`
  }
}
